// --- BASE ---
import React, { FormEvent, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

// --- COMPONENTS ---
import AlertBox from '../components/AlertBox';

// --- INTERFACES ---
interface IErrors {
	email?: string;
	password?: string;
}

interface IParams {
	api_hostname: string;
	request_enabled: boolean | string;
}

interface IProps {
	params: IParams;
}

// *** FUNCTIONAL COMPONENT ***
const Login = (props: IProps) => {
	const { params }: IProps = { ...props };

	// --- TOKEN ---
	const token = localStorage.getItem('token');

	// --- CONSTANTS ---
	const apiHostname = params.api_hostname;
	const requestEnabled = params.request_enabled;

	// --- STATES ---
	const [alert, setAlert] = useState<object>({});
	const [disabled, setDisabled] = useState<boolean>(true);
	const [email, setEmail] = useState<string>('');
	const [errors, setErrors] = useState<IErrors>({});
	const [hideReset, setHideReset] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [password, setPassword] = useState<string>('');
	const [showForgot, setShowForgot] = useState<boolean>(false);

	// --- LOCAL FUNCTIONS ---
	function cancelForgot() {
		setHideReset(false);
		setShowForgot(false);

		setAlert({
			message: '',
			show: false,
			status: 'info'
		});
	}
	function checkToken(token: string) {
		console.log(token);

		setDisabled(true);
		setIsLoading(true);

		fetch(apiHostname + '/authenticate/validate', {
			headers: {
				'Accept': 'application/json',
				'Authorization': 'Bearer ' + token,
				'Content-Type': 'application/json'
			},
			method: 'GET',
			mode: 'cors'
		})
			.then((response) => response.json())
			.then((result) => {
				const errors = typeof result === 'object' && result !== null && 'errors' in result && typeof result.errors === 'object' && result.errors !== null ? result.errors : {};
				const message = typeof result === 'object' && result !== null && 'message' in result && typeof result.message === 'string' && result.message !== null ? result.message : 'Unknown error.';
				const status = typeof result === 'object' && result !== null && 'status' in result && typeof result.status === 'string' && result.status !== null ? result.status : 'error';

				setErrors(errors);

				if (status === 'success') {
					const data = typeof result === 'object' && result !== null && 'data' in result && typeof result.data === 'object' && result.data !== null ? result.data : null;
					console.log({ data });

					const account = data !== null && 'account' in data && typeof data.account === 'object' && data.account !== null ? data.account : null;
					console.log({ account });

					const accountStatus = account !== null && 'status' in account && typeof account.status === 'string' && account.status !== null ? account.status : null;
					console.log({ accountStatus });

					switch (accountStatus) {
						case 'denied':
							window.location.assign('/denied');
							break;

						case 'requested':
							window.location.assign('/verify');
							break;

						case 'verified':
							window.location.assign('/under-review');
							break;

						case 'approved':
							window.location.assign('/warranty-claims');
							break;

						default:
							window.location.assign('/error');
					}

					// } else {
					// setAlert({
					// 	message: message,
					// 	show: true,
					// 	status: status
					// });
				}
			})
			.finally(() => {
				setDisabled(false);
				setIsLoading(false);
			});
	}

	function handleSubmit(e: FormEvent<HTMLFormElement>) {
		console.log('handleSubmit called');

		e.preventDefault();

		setDisabled(true);
		setIsLoading(true);

		fetch(apiHostname + '/authenticate', {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST',
			mode: 'cors',
			body: JSON.stringify({
				email: email,
				password: password
			})
		})
			.then((response) => response.json())
			.then((result) => {
				const errors = typeof result === 'object' && result !== null && 'errors' in result && typeof result.errors === 'object' && result.errors !== null ? result.errors : {};
				const message = typeof result === 'object' && result !== null && 'message' in result && typeof result.message === 'string' && result.message !== null ? result.message : 'Unknown error.';
				const status = typeof result === 'object' && result !== null && 'status' in result && typeof result.status === 'string' && result.status !== null ? result.status : 'error';

				setErrors(errors);

				if (status === 'success') {
					const data = typeof result === 'object' && result !== null && 'data' in result && typeof result.data === 'object' && result.data !== null ? result.data : null;

					const accessToken = data !== null && 'access_token' in data && typeof data.access_token === 'string' && data.access_token !== null ? data.access_token : null;

					if (accessToken !== null) {
						// Store the token in the user brower's local storage.
						localStorage.setItem('token', accessToken);

						window.location.assign('/warranty-claims');
					} else {
						setAlert({
							message: 'There was an error retrieving login credentials. Please try again.',
							show: true,
							status: 'error'
						});
					}
				} else {
					setAlert({
						message: message,
						show: true,
						status: status
					});
				}
			})
			.finally(() => {
				setDisabled(false);
				setIsLoading(false);
			});
	}

	function resetPassword() {
		console.log('resetPassword called');

		setDisabled(true);
		setIsLoading(true);

		fetch(apiHostname + '/authenticate/forgot', {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST',
			mode: 'cors',
			body: JSON.stringify({
				email: email
			})
		})
			.then((response) => response.json())
			.then((result) => {
				const errors = typeof result === 'object' && result !== null && 'errors' in result && typeof result.errors === 'object' && result.errors !== null ? result.errors : {};
				const message = typeof result === 'object' && result !== null && 'message' in result && typeof result.message === 'string' && result.message !== null ? result.message : 'Unknown error.';
				const status = typeof result === 'object' && result !== null && 'status' in result && typeof result.status === 'string' && result.status !== null ? result.status : 'error';

				setErrors(errors);

				if (status === 'success') {
					// const data = typeof result === 'object' && result !== null && 'data' in result && typeof result.data === 'object' && result.data !== null ? result.data : null;

					// const accessToken = data !== null && 'access_token' in data && typeof data.access_token === 'string' && data.access_token !== null ? data.access_token : null;

					// if (accessToken !== null) {
					// 	// Store the token in the user brower's local storage.
					// 	localStorage.setItem('token', accessToken);

					// 	window.location.assign('/warranty-claims');
					// } else {
					// 	setAlert({
					// 		message: 'There was an error retrieving login credentials. Please try again.',
					// 		show: true,
					// 		status: 'error'
					// 	});

					setHideReset(true);
				}
				// } else {
				setAlert({
					message: message,
					show: true,
					status: status
				});
				// }
			})
			.finally(() => {
				setDisabled(false);
				setIsLoading(false);
			});
	}

	// --- USE EFFECTS ---
	useEffect(() => {
		if (token !== null) {
			checkToken(token);
		} else {
			setIsLoading(false);
			setDisabled(false);
		}
	}, []);

	return (
		<div>
			<div
				className="loading"
				hidden={!isLoading}>
				Loading...
			</div>

			<AlertBox
				alert={alert}
				onClose={() => setAlert({})}
			/>

			<form
				method="post"
				onSubmit={handleSubmit}>
				<div
					className="form-group mb-3"
					hidden={hideReset}>
					<input
						className={'form-control' + (errors?.email ?? false ? ' is-invalid' : '')}
						disabled={disabled}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="Email Address"
						required
						type="email"
						value={email}
					/>
					<div className="invalid-feedback">{errors?.email ?? ''}</div>
				</div>

				<div
					className="form-group mb-3"
					hidden={showForgot ? true : false}>
					<input
						className={'form-control' + (errors?.password ?? false ? ' is-invalid' : '')}
						disabled={disabled}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Password"
						required
						type="password"
						value={password}
					/>
					<div className="invalid-feedback">{errors?.password ?? ''}</div>
				</div>

				<div hidden={showForgot ? true : false}>
					<div className="mb-3">
						<a
							href="#"
							onClick={() => setShowForgot(!showForgot)}>
							Forgot Your Password?
						</a>
						{requestEnabled && (
							<a
								className="ms-2"
								href="/request">
								Request a Login
							</a>
						)}
					</div>

					<div className="buttons">
						<button
							className="btn btn-primary"
							disabled={disabled}
							type="submit">
							Log In
						</button>
					</div>
				</div>

				<div hidden={showForgot ? false : true}>
					<div className="mb-3">
						<a
							href="#"
							onClick={() => cancelForgot()}>
							Cancel
						</a>
					</div>

					<div
						className="buttons"
						hidden={hideReset}>
						<button
							disabled={disabled}
							onClick={() => resetPassword()}
							className="btn btn-primary"
							type="button">
							Reset Password
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

// --- RENDER ---
ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(<Login params={window.params} />);
